import { Observable } from 'rxjs';
import { Category } from './category.models';
import { Channel } from './channel.models';
import { Badge, Metrics, Tag } from './core.models';
import { Genre } from './genre.models';
import {
  MediaSource,
  MediaSourceStatus,
  MediaSourceType
} from './media-source.models';
import { Person } from './person.models';
import { Program } from './program.models';
import { Season } from './season.models';
import { FreeRequestParams } from './shared.models';
import { Thematic } from './thematic.models';

export enum ContentType {
  audio = 'audio',
  video = 'video',
  image = 'image'
}

export type Content = FreeRequestParams & {
  id: string;
  type: ContentType;
  title: string;
  slug: string;
  description: string;
  accessControlId: string;
  channel: Channel;
  ageRating: number;
  program: Program;
  thematic: Thematic;
  season: Season;
  genres: Genre[];
  persons: Person[];
  tags: Tag[];
  badges: Badge[];
  category: Category;
  published: boolean;
  publishedAt: string;
  mediaSource: MediaSource;
  userInteractions?: ['favorite', 'like', 'dislike']; // relatedObjectName
  watchingRecord?: {
    id: string;
    duration: number;
    issuedAt: string;
  };
  countMetrics$?: Observable<Pick<Metrics, 'playsCount'>>;
};

export type ContentListParams = FreeRequestParams & {
  type?: ContentType;
  title?: string;
  slug?: string;
  mediaSourceId?: string;
  mediaSourceStatus?: MediaSourceStatus;
  mediaSourceType?: MediaSourceType;
  accessControlId?: string;
  channelId?: string;
  ageRating?: number;
  programId?: string;
  thematicId?: string;
  categoryId?: string;
  seasonId?: string;
  genreIds?: string[];
  personIds?: string[];
  tagId?: string;
  badgeIds?: string[];
  publishedAt?: string;
  published?: boolean;
};

export type CreateContentParams = {
  contents: {
    programId?: string;
    seasonId?: string;
    tagIds?: string[];
    badgeIds?: string[];
    personIds?: string[];
    genreIds?: string[];
    title?: string;
    publishedAt?: string;
    description?: string;
    accessControlId?: string;
    thumbnail?: string;
    ageRating?: number;
  };
  mediaSource: {
    id: string;
    status: MediaSourceStatus;
    type: MediaSourceType;
  };
};

export type ContentUpdateParams = {
  programId?: string;
  seasonId?: string;
  tagIds?: string[];
  badgeIds?: string[];
  personIds?: string[];
  genreIds?: string[];
  title?: string;
  publishedAt?: string;
  description?: string;
  accessControlId?: string;
  thumbnail?: string;
  ageRating?: number;
  mediaSource?: {
    id: string;
    status: MediaSourceStatus;
    type: MediaSourceType;
  };
};
